import React, { Component } from 'react';
//import ReactDOM from 'react-dom';
import firebase from './../Firestore'
import { Link } from 'react-router-dom';
//import FileUploader from "react-firebase-file-uploader";

import config from 'react-global-configuration';

import CategoriaSelector from './CategoriaSelector'
import NavBar from './NavBar'

class AdicionalCreate extends Component {

  categoriaID = React.createRef();

  constructor() {
    super();
    this.ref = firebase.firestore().collection('adicionales');
    this.state = {
      nombre: '',
      categoriaID: '',
      precio: '',
      enStock: 1
    };
  }


  onChange = (e) => {
    //console.log("ref", this.categoriaID.current.value)

    const state = this.state
    state[e.target.name] = e.target.value;
    this.setState(state);

  }

  onSubmit = (e) => {
    e.preventDefault();

    const { nombre, categoriaID, precio, enStock } = this.state;

    this.ref.add({
      nombre,
      categoriaID: this.categoriaID.current.value,
      precio: Number(this.state.precio),
      enStock: Boolean(this.state.enStock)
    }).then((docRef) => {
      this.setState({
        nombre: '',
        categoriaID: '',
        precio: '',
        enStock: ''
      });
      this.props.history.push("/admin/adicional/lista")
    })
    .catch((error) => {
      console.error("Error adding document: ", error);
    });
  }


  render() {
    const { nombre, categoriaID, precio, enStock } = this.state;
    return (
      <div className="container">
        <NavBar history={this.props.history} />
        <div className="panel panel-default">
          <div className="panel-heading">
            <h3 className="panel-title">
              AGREGAR ADICIONAL
            </h3>
          </div>
          <div className="panel-body">
            <form onSubmit={this.onSubmit}>
              <div className="form-group">

                <label htmlFor="nombre">Nombre del nuevo adicional:</label>
                <input type="text" className="form-control" name="nombre" value={nombre} onChange={this.onChange} placeholder="Nombre" required />
              </div>

              <div className="form-group">
                <label htmlFor="categoriaID">Categoria:</label>
                <CategoriaSelector name="categoriaID" categoriaID={this.categoriaID} esAdicional={true} onChange={this.onChange} />

              </div>

              <div className="form-group">
                <label htmlFor="precio">Precio:</label>
                <input id="precio" type="number" className="form-control" name="precio" value={typeof precio !== 'object'? precio : ""} onChange={this.onChange} placeholder="Precio único" min="1" required={this.state.precioUnico ? true : false} />
              </div>



              <select value={enStock} name="enStock" onChange={this.onChange} className="custom-select mt-2">
                <option value={true}>Hay en stock</option>
                <option value={false}>No hay en stock</option>
              </select>


              <button type="submit" className="btn btn-success mt-2">Agregar adicional</button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default AdicionalCreate;
